(function () {
  'use strict';

  function getEls() {
    return {
      button: document.getElementById('whatsappButton'),
      popup: document.getElementById('whatsappPopup'),
      close: document.getElementById('closePopup')
    };
  }

  function open(popup) { popup.classList.add('active'); }
  function close(popup) { popup.classList.remove('active'); }
  function toggle(popup) { popup.classList.toggle('active'); }

  // Делегирование: работает даже если Impulse перерисовал DOM
  document.addEventListener('click', (e) => {
    const { button, popup, close: closeBtn } = getEls();
    if (!popup) return;

    if (button && e.target.closest('#whatsappButton')) {
      e.preventDefault();
      toggle(popup);
      return;
    }

    if (closeBtn && e.target.closest('#closePopup')) {
      e.preventDefault();
      close(popup);
      return;
    }

    // клик вне попапа закрывает
    if (popup.classList.contains('active')) {
      const clickedInside = popup.contains(e.target) || (button && button.contains(e.target));
      if (!clickedInside) close(popup);
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    const { popup } = getEls();
    if (!popup) return;
    close(popup);
  });
})();